import { InvitedTeamsResponse, InvitedTeamResponse } from '../models/api';
import { deleteData, getData, postData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (): Promise<ResponseData<InvitedTeamsResponse>> =>
  getData('api/teamInvites/');

export const confirm = async (
  teamMemberReference: string
): Promise<ResponseData<InvitedTeamResponse>> =>
  postData<InvitedTeamResponse>(`api/teamInvites/${teamMemberReference}`, {});

export const remove = async (
  teamMemberReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/teamInvites/${teamMemberReference}`);
